import { lazy, Suspense } from "react";
import { RouteObject } from "../../../helpers/tixxt-router";
import Loading from "../../shared/Loading";

const Support = lazy(() => import("./index"));
const SupportChatReportDetail = lazy(() => import("./SupportChatReportDetail"));
const SupportChatHistoryPage = lazy(() => import("./SupportChatHistoryPage"));

const routes: RouteObject[] = [
  {
    path: "/support",
    element: (
      <Suspense fallback={<Loading />}>
        <Support />
      </Suspense>
    ),
  },
  {
    path: "/support/history",
    element: (
      <Suspense fallback={<Loading />}>
        <SupportChatHistoryPage />
      </Suspense>
    ),
  },
  {
    path: "/support/report/:id",
    element: (
      <Suspense fallback={<Loading />}>
        <SupportChatReportDetail />
      </Suspense>
    ),
  },
];

export default routes;
